import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class SmoothImage {
	constructor(
		image,
		args = {
			fromY: 60,
			parentToY: -50,
			scale: 1.25,
		},
		timelineMap
	) {
		this.image = image;
		this.args = { fromY: 60, parentToY: -50, scale: 1.25, ...args };
		this.timelineMap = timelineMap;

		this.init();
	}

	init() {
		this.image.parentElement.style.overflow = "hidden";
		this.image.parentElement.style.borderRadius = window.getComputedStyle(this.image).borderRadius;

		this.image.style.borderRadius = "0";

		const row = this.image.closest(".fl-row");
		const tl = this.timelineMap.get(row);

		if (tl) {
			tl.add(this.tl(), 0);
		}
	}

	tl() {
		const tl = gsap.timeline({
			onStart: () => {
				console.log("start");
			},
			onComplete: () => {
				console.log("complete");
			},
		});

		gsap.set(this.image, {
			scale: this.args.scale,
		});

		tl.from(
			this.image,
			{
				y: this.args.fromY,
				duration: 1,
				easing: "power1.inOut",
			},
			0
		);

		if (this.args.parentToY) {
			tl.to(
				this.image.parentNode,
				{
					y: this.args.parentToY,
					duration: 1,
					easing: "power1.inOut",
				},
				0
			);
		}

		return tl;
	}
}

export default SmoothImage;
